const RouterConst = {
    Login: '/login',
    VerifyCode: '/verifyCode',
    PayDetail: '/payDetail',
    DepositPayDetail: '/depositPayDetail',
    PayResult: '/payResult'
}
export default RouterConst